import { Controller } from '@hotwired/stimulus';

// <details> 要素の外側をクリックしたときに閉じる
export default class extends Controller {
  // action="click@document->details-auto-close#closeOnOutsideClick"
  closeOnOutsideClick({ target }) {
    if (!this.element.open) return;
    if (this.element.contains(target)) return;

    this.element.open = false;
  }
}
